module.exports = __webpack_public_path__ + "img/sparkling.1ef8a8d7.png";